import cx from 'classnames'
import { lang } from 'enablex/shared'
import _ from 'lodash'
import moment from 'moment'
import React, { FC } from 'react'

import DepartmentActions from './DepartmentActions'
import style from './style.scss'

interface Department {
  id: number
  name: string
  email?: string
  status: 'active' | 'suspended'
  workspaceId: string
  createdAt: Date
  updatedAt: Date
}

interface Props {
  department: Department
  currentUserEmail: string
  currentUserisAdminUser: boolean
  currentUserisSuperAdmin: boolean
  currentUserisEnablexAdmin: boolean
  onDepartmentUpdated: () => void
}

const Department: FC<Props> = ({ department, currentUserEmail, currentUserisAdminUser, currentUserisSuperAdmin, currentUserisEnablexAdmin, onDepartmentUpdated }) => {
  const timeFormat = 'DD/MM/YY hh:mm A'

  return (
    <div className={style.departmentCard} key={`department-${department.id}`}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '1rem 0.6rem' }}>
        <div className={cx(style.details, style.pullLeft)}>
          <div style={{ display: 'flex', gap: '15px' }}>
            <div className={style.picture}>
              <div className={style.userNoImage}>
                <div style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#646464',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontSize: '18px',
                  fontWeight: 'bold'
                }}>
                  {department.name.charAt(0).toUpperCase()}
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className={style.nameZone}>
                {department.name}
              </div>
              <div className={style.userRole}>
                <div>
                  <strong style={{
                    color: department.status === 'active' ? '#0f5132' : '#842029',
                    backgroundColor: department.status === 'active' ? '#d1e7dd' : '#f8d7da',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    textTransform: 'capitalize'
                  }}>
                    {department.status}
                  </strong>
                </div>
              </div>
              <div className={style.userEmail}>
                <span className={style.emailField}>
                  {department.email || 'No email provided'}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={style.dates}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span className={style.field}>
              <span style={{fontFamily: 'Barlow SemiBold'}}>Created:&nbsp;</span>
              {moment(department.createdAt).format(timeFormat)}
            </span>
            <span className={style.field}>
              <span style={{fontFamily: 'Barlow SemiBold'}}>Last Updated:&nbsp;</span>
              {moment(department.updatedAt).format(timeFormat)}
            </span>
          </div>
          <div>
            {(currentUserisSuperAdmin || (currentUserisAdminUser && !currentUserisEnablexAdmin) || (currentUserisAdminUser && currentUserisEnablexAdmin)) && (
              <DepartmentActions
                department={department}
                onDepartmentUpdated={onDepartmentUpdated}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Department
